import React, { Component } from 'react';
import Whatsapp from "../images/Maevelifestyle/whatsapp.png"
import Instagram from "../images/Maevelifestyle/instagram.png"
import Music from "../images/Maevelifestyle/tik-tok.png"
import { report } from '../services';
export default class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: "",
      lastName: "",
      email: "",
      message: "",
      errors: {},
      isMailSent:"false"
    };
    this.submitHandler = this.submitHandler.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }
  validateForm = () => {
    const { firstName, email, message } = this.state;
    let errors = {};
    let formIsValid = true;

    if (!firstName) {
      formIsValid = false;
      errors["firstName"] = "First Name is required";
    }

    if (!email) {
      formIsValid = false;
      errors["email"] = "Email is required";
    } else if (!email.match(/^\S+@\S+\.\S+$/)) {
      formIsValid = false;
      errors["email"] = "Invalid email address";
    }

    if (!message) {
      formIsValid = false;
      errors["message"] = "Message is required";
    }

    this.setState({ errors });
    return formIsValid;
  };
  handleInputChange = (event) => {
  
    const { name, value } = event.target;
    this.setState((prevState) => ({
      [name]: value,
      isMailSent:"false",
      errors: {
        ...prevState.errors,
        [name]: "", // Clear the error for this field
      },
    }));
  };

submitHandler(e){
  e.preventDefault();
  if (this.validateForm()) {
    console.log("Form Submitted", this.state);
    const postData = {
      "functionName": "sellerEnquiry",
      "firstname": this.state.firstName,
      "lastname":this.state.lastName,
      "emailid":this.state.email,
      "message":this.state.message,
      "seller_id":window.sessionStorage.getItem('sellerId')
  }
  report(postData).then((data) => {
      if (data.data.success === "1") {
        {console.log("dataaaaaaaaaaaaaaaaaaaaaaa",data)}
        this.setState({
          firstName: "",
          lastName: "",
          email: "",
          message: "",
          errors: {},
          isMailSent:"true"
        });
      }
      else {
        alert(data.data.errorMessage)
        this.setState({
          firstName: "",
          lastName: "",
          email: "",
          message: "",
          errors: {},
          isMailSent:"false"
        });
      }
    })
    // Reset the form
    
  }

}
  render() {
    let siteDetails = sessionStorage.getItem("siteDetails");
    let siteDetailsArray = siteDetails ? JSON.parse(siteDetails) : [];
    
    return (
      <div className='contact-div '>
        <div className="row mx-0 contact-wrap-space">
          <div className="col-lg-6 col-md-6 col-12 pl-lg-5 pl-md-5 mb-5">
            <div className='contact-head'>CONTACT US</div>
            <div className='contact-data ml-2'>
              <div>Email : info@maevelifestyle.com</div>
              <div>Phone : +971 585965377</div>
            </div>

            <div>
              <div className='contact-head'>
                Connect with us
              </div>
              <div className='pt-3 social-icons ml-3'>
              {siteDetailsArray.siteData[0]?.sellerData?.[0]?.sellerFooterData?.map((link, index) => (
                     <a href={link.url}><img src={link.name == "Instagram" ?Instagram :link.name == "TikTok" ? Music:link.name == "Whatsapp" ?Whatsapp: ""} title = {link.name} className='img-fluid mr-4' width="50" height="50" alt=""></img></a>
                    ))}
                {/* <img src={Whatsapp} alt="Whatsapp" className='img-fluid mr-4' width="50" height="50" />
                <img src={Instagram} alt="Instagram" className='img-fluid mr-4' width="50" height="50" />
                <img src={Music} alt="Music" className='img-fluid' width="50" height="50" /> */}
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className='form-para'>If you have any questions or comments, please contact us via
              email or phone, or send us a message using the contact form.</div>
              <form onSubmit={this.submitHandler}>
            <div>
            
              <label htmlFor="">Name <span className='required'>(required)</span></label>
              <div className='row mb-3'>
                <div className="col-6">
                  <label htmlFor="">First Name</label>
                  <input type="text"   className={`form-control`}  name="firstName"
                     value={this.state.firstName}
                    onChange={this.handleInputChange}/>
                   {this.state.errors.firstName && <small className="error">{this.state.errors.firstName}</small>}
                </div>
                <div className="col-6">
                  <label htmlFor="">Last Name</label>
                  <input type="text" className='form-control'  name="lastName"
                    value={this.state.lastName}
                    onChange={this.handleInputChange}/>
                </div>
              </div>
              <div className='row mb-3'>
                <div className="col-12">
                  <label htmlFor="">Email <span className='required'>(required)</span></label>
                  <input type="email"   className={`form-control`}  name="email" 
                    value={this.state.email}
                    onChange={this.handleInputChange}/>
                     {this.state.errors.email && <small className="error">{this.state.errors.email}</small>}
                </div>
              </div>
              <div className='row mb-3'>
                <div className="col-12">
                  <label htmlFor="">Message <span className='required'>(required)</span></label>
                  <textarea rows="4" className={`form-control`} name="message"
                    value={this.state.message}
                    onChange={this.handleInputChange} />
                      {this.state.errors.message && <small className="error">{this.state.errors.message}</small>}
                </div>
              </div>
              <div className="row">
                <div className="col-2 col-lg-2 col-md-4">
                  <button className='btn-submit'>Submit</button>
                </div>
              </div>
            </div>
            </form>
            {this.state.isMailSent === "true" && (
              <div className="mt-3">
                <label>Mail sent successfully. Our team will contact you soon.</label>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}
